import { CHS_PROJECT_NAME } from '../../constants';
import AddOnsItem from '../ViewPatientRegistration/AddOnsItem';
import ViewPackageItem from '../ViewPatientRegistration/ViewPackageItem';
import { ClipboardIcon } from '@/assets/svg';
import Invoice from '@/module/all-screenings/component/Invoice';
import { ClearComponent } from '@/new-components/ClearComponent';
import {
  Grid,
  Typography,
  makeStyles,
  Divider,
  Paper,
  Box,
  TextField,
  withStyles,
} from '@material-ui/core';
import { isEmpty } from 'lodash';
import React, { useMemo } from 'react';

const useStyles = makeStyles({
  container: {
    display: 'flex',
  },

  leftContainer: {
    overflowY: 'scroll',
    overflowX: 'hidden',
    padding: '20px 40px',
    flex: '1',
    borderRight: '1px solid #F1F1F1',
    height: 'calc(100vh - 282px)',
  },

  rightContainer: {
    overflow: 'scroll',
    padding: '16px 40px',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    height: 'calc(100vh - 282px)',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 16,
    fontSize: 20,
    gap: 8,
  },
  disabledSwitch: {
    pointerEvents: 'none',
    cursor: 'not-allowed',
  },
});

const CustomTextField = withStyles({
  root: {
    fontSize: 20,

    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      height: 48,
    },
    '& .MuiOutlinedInput-input': {
      marginRight: 0,
      paddingLeft: 5,
      fontSize: 16,
    },

    '& .MuiInputBase-inputMultiline': {
      '&.MuiInputBase-input': {
        marginLeft: 0,
      },
    },

    '& .Mui-disabled': {
      '&.MuiOutlinedInput-root': {
        backgroundColor: '#f6f6f6',
      },
    },
    '& .MuiInputBase-adornedStart': {
      '& .MuiTypography-root': {
        fontSize: 16,
        color: '#333333',
      },
      '& .MuiInputAdornment-positionStart': {
        marginRight: 0,
      },
      '& input': {
        marginLeft: 0,
      },
    },
  },
})(TextField);

const CustomTitleSubLabel = withStyles({
  root: {
    fontWeight: 600,
    color: '#666666',
  },
})(Typography);

const sortByCategory = (list) => {
  return [...(list || [])].sort((a, b) => {
    const categoryA = (a.category || '').toLowerCase();
    const categoryB = (b.category || '').toLowerCase();
    return categoryA.localeCompare(categoryB);
  });
};

const SelectServiceStep = ({
  apptData,
  dataInfo,
  projectInfo,
  paymentStatus,
  packageInfo,
  totalCost,
  totalAmountDefault,
  lstOptionalTests,
  restrictedTestIds,
  locationId,
  showCodeField,
  formValue,
  setFormValue,
  isFollowUp,
  originalLstTestsForPreCalculate,
}) => {
  const classes = useStyles();
  const lstProfiles = dataInfo?.lstProfiles || [];
  const lstTests = dataInfo?.lstTests || [];
  const newListProfiles = useMemo(() => {
    if (!lstProfiles.length && !lstTests.length) return [];
    let newList = [];
    if (lstProfiles.length > 0) {
      newList.push({
        category: 'Profiles',
        items: lstProfiles,
      });
    }
    const combinedList = newList.concat(lstTests || []);
    // Sort by category alphabetically
    return sortByCategory(combinedList);
  }, [lstProfiles, lstTests]);

  const sortedLstTests = useMemo(() => {
    return sortByCategory(lstTests);
  }, [lstTests]);

  return (
    <Paper square elevation={0} className={classes.container}>
      <Box
        flexDirection="column"
        className={classes.leftContainer}
        gridGap={16}
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography className={classes.title}>
              <ClipboardIcon style={{ color: '#666666' }} />
              Selected packages
            </Typography>
          </Grid>
          {!isEmpty(dataInfo?.lstPackages) && (
            <Grid item xs={12}>
              <ViewPackageItem
                packageDetail={packageInfo}
                ignoredTests={dataInfo?.ignoredTests}
                ignoredProfiles={dataInfo?.ignoredProfiles}
                restrictedTestIds={restrictedTestIds}
                locationId={locationId}
              />
            </Grid>
          )}

          {!isEmpty(dataInfo.lstPackages) &&
            ((!isEmpty(dataInfo.lstProfiles) && !isFollowUp) ||
              !isEmpty(dataInfo.lstTests)) && (
              <Grid item xs={12}>
                <Divider light variant="middle" />
              </Grid>
            )}
          {!isEmpty(dataInfo.lstProfiles) && !isFollowUp ? (
            <Grid item xs={12}>
              <AddOnsItem listData={newListProfiles} />
            </Grid>
          ) : !isEmpty(dataInfo.lstTests) ? (
            <Grid item xs={12}>
              <AddOnsItem listData={sortedLstTests} />
            </Grid>
          ) : null}
        </Grid>
      </Box>
      <Box className={classes.rightContainer}>
        <Invoice
          apptData={apptData}
          lstTests={dataInfo.lstTests}
          lstProfiles={dataInfo?.lstProfiles}
          lstPackages={dataInfo?.lstPackages}
          ignoredProfiles={dataInfo?.ignoredProfiles}
          ignoredTests={dataInfo?.ignoredTests}
          lstOptionalTests={lstOptionalTests}
          staffType={dataInfo?.staffType}
          projectInfo={projectInfo}
          paymentStatus={paymentStatus}
          dataInfo={dataInfo}
          originalLstTestsForPreCalculate={originalLstTestsForPreCalculate}
          isFollowUp={isFollowUp}
        />
        {showCodeField &&
          formValue &&
          !isFollowUp &&
          projectInfo?.name === CHS_PROJECT_NAME && (
            <Box>
              <CustomTitleSubLabel>Code</CustomTitleSubLabel>
              <CustomTextField
                fullWidth
                variant="outlined"
                placeholder="Enter code"
                value={formValue?.code || ''}
                onChange={(e) =>
                  setFormValue({ ...formValue, code: e.target.value })
                }
                InputProps={{
                  endAdornment: (
                    <ClearComponent
                      id="code"
                      value={formValue.code}
                      onClear={() => setFormValue({ ...formValue, code: '' })}
                    />
                  ),
                }}
              />
            </Box>
          )}
      </Box>
    </Paper>
  );
};

export default SelectServiceStep;
